exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host .container {\n  padding-top: 70px;\n  height: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/app/components/dashboard/stats-detail/stats-detail.component.scss
// module id = 172
// module chunks = 0